import React, { useEffect, useState } from "react";
const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;
export default function TestingCorsApis() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  console.log("render TestingCorsApis");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(
          `https://mgmt-util2.${backend_api_base_url}/get_tenant_plan`,
          {
            method: "GET",
            headers: {
              Authorization: localStorage.getItem("token"), // use your token
            },
          }
        );

        const json = await res.json();

        setData(json);
      } catch (err) {
        console.error("API error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // 👇 Loader
  if (loading) {
    return <div>Loading...</div>;
  }

  // 👇 Error state
  if (error) {
    return <div>Error loading data</div>;
  }

  // 👇 Success state
  return (
    <div>
      <h3>Tenant Plan</h3>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}